
// export function formatToText(data) {
//     if (typeof data === "string") {
//       return data?.replace(/\n/g, "<br/>") // Return the string as is
//     }
  
//     let textOutput = "";
  
//     if (Array.isArray(data)) {
//         data.forEach((item) => {
//           textOutput += `• ${item}\n\n`;
//         });
//       } else if (typeof data === "object" && data !== null) {
//       for (const [key, value] of Object.entries(data)) {
//         textOutput += `<b>${key.replace(/_/g, " ")}:</b>\n${value}\n\n`;
//       }
//     }
  
//     return textOutput;
//   }
export function formatToText(data) {
  // If it's a string, return the string with newlines replaced by <br/>.
  if (typeof data === "string") {
      return data.replace(/\n/g, "<br/>");
  }
  // Numbers and booleans (e.g. level_of_visit: 4) used to come back as "".
  if (typeof data === "number" || typeof data === "boolean") {
      return String(data);
  }

  let textOutput = "";

  // If it's an array, iterate and format each item.
  if (Array.isArray(data)) {
      data.forEach((item) => {
          textOutput += `• ${formatToText(item)}\n\n`; // Recursively format array items.
      });
  } 
  // If it's an object, format the key-value pairs.
  else if (typeof data === "object" && data !== null) {
      for (const [key, value] of Object.entries(data)) {
          // Add the formatted key and value, recursively calling for nested values.
          textOutput += `<b>${key.replace(/_/g, " ")}:</b>\n${formatToText(value)}\n\n`;
      }
  }

  return textOutput;
}
